/**
 * Quando o preenchimento guiado abre o primeiro campo pendente ao NASCER:
 *
 * - `wide`: só no palco largo — as páginas determinísticas, em que a folha do
 *   palco estreito cobriria a página que já é o formulário;
 * - `always`: também no palco estreito — os cards da conversa, que chegam
 *   pedindo a resposta (#4879);
 * - `never`: não abre — o card remontado do histórico, cujo gesto já foi gasto.
 *
 * Ausente vale `wide`.
 */
export type GuidedOpen = 'wide' | 'always' | 'never';

export function guidedOpensOnMount(mode: GuidedOpen | undefined, narrow: boolean): boolean {
  return mode === 'always' || (mode !== 'never' && !narrow);
}
